import { gql } from 'graphql-request'

export const GET_NAIIN_INFORMATION = gql`
  query GetNaiinInformation($token: String!) {
    getNaiinInformation(token: $token) {
      email
    }
  }
`
